import {
  FETCH_WHITELIST_DETAILS,
  FETCH_WHITELIST_DETAILS_FAIL,
  FETCH_WHITELIST_DETAILS_SUCCESS,
  SELECT_WHITELIST_ID,
  SELECT_WHITELIST_CUSTOMERS,
  APPROVE_CUSTOMERS,
  APPROVE_CUSTOMERS_FAIL,
  APPROVE_CUSTOMERS_SUCCESS,
  DELETE_CUSTOMERS,
  DELETE_CUSTOMERS_FAIL,
  DELETE_CUSTOMERS_SUCCESS,
  UPDATE_WHITELIST_NAME,
  UPDATE_WHITELIST_NAME_FAIL,
  UPDATE_WHITELIST_NAME_SUCCESS,
  CLOSE_SUCCESS_MSG_POPUP
} from '../../actions/cm/whitelistDetails';
import { DEFAULT_PAGE_SIZE } from '../../../pages/constants/cmConstants';

export const initialState = {
  isLoading: false,
  hasError: false,
  errorMessage: '',
  isLoadingList: false,
  currentPage: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  whitelistDetails: {},
  selectedIds: [],
  selectedCustomers: [],
  showSuccessMsg: false
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_WHITELIST_DETAILS:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        showSuccessMsg: false,
        currentPage: payload.currentPage,
        pageSize: payload.pageSize
      };
    case FETCH_WHITELIST_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        whitelistDetails: payload.whitelistDetails
      };
    case FETCH_WHITELIST_DETAILS_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        errorMessage: payload.message
      };
    case SELECT_WHITELIST_ID:
      return { ...state, selectedIds: payload };
    case SELECT_WHITELIST_CUSTOMERS:
      return { ...state, selectedCustomers: payload };
    case APPROVE_CUSTOMERS:
    case DELETE_CUSTOMERS:
    case UPDATE_WHITELIST_NAME:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };
    case APPROVE_CUSTOMERS_SUCCESS:
    case DELETE_CUSTOMERS_SUCCESS:
    case UPDATE_WHITELIST_NAME_SUCCESS:
      return {
        ...state,
        isLoading: false,
        showSuccessMsg: true,
        selectedIds: []
      };
    case APPROVE_CUSTOMERS_FAIL:
    case DELETE_CUSTOMERS_FAIL:
    case UPDATE_WHITELIST_NAME_FAIL:
      return {
        ...state,
        hasError: true,
        isLoading: false,
        errorMessage: payload.message
      };
    case CLOSE_SUCCESS_MSG_POPUP:
      return {
        ...state,
        showSuccessMsg: false
      };
    default:
      return state;
  }
}
